import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Markdown from "react-remarkable";
import DigiFormField from "./DigiFormField";
import DigiFormSelect from "./DigiFormSelect";
import DigiFormTextArea from "./DigiFormTextArea";
import DigiFormDateTime from "./DigiFormDateTime";
import DigiFormCheckBox from "./DigiFormCheckBox";
import DigiFormRadioButtonsStd from "./DigiFormRadioButtons";
import DigiFormLocationsPools from "./DigiFormLocationsPools";
import DigiFormCustomFieldsQuestions from "./DigiFormCustomFieldsQuestions";
import DigiFormCustomFieldsAnswers from "./DigiFormCustomFieldsAnswers";
import DigiFormHidden from "./DigiFormHidden";
import DigiFormToggle from "./DigiFormToggle";
import DigiFormUsers from "./DigiFormUsers";
import DigiFormSignaturesFields from "./DigiFormSignaturesFields";
import DigiFormAttachments from "../DigiForm/DigiFormAttachments";
import DigiFormRecordSignature from "../DigiForm/DigiFormRecordSignature";
import DigiFormToggleAttachments from "../DigiForm/DigiFormToggleAttachments";
import DigiFormTogglePublicForm from "../DigiForm/DigiFormTogglePublicForm";
import DigiFormDescription from "../DigiForm/DigiFormDescription";
import DigiFormLocations from "../DigiForm/DigiFormLocations";
import DigiFormLocationsToggleAll from "../DigiForm/DigiFormLocationsToggleAll";
import DigiFormNote from "./DigiFormNote";


const checkAndConvertFieldType = (fieldType) => {
  if (fieldType instanceof String) {
    return fieldType;
  } else {
    switch (fieldType) {
      case 0:
        return "text";
      case 1:
        return "number";
      default:
        return fieldType;
    }
  }
};

const checkAndConvertSelectOptions = (selectOptions) => {
  if (selectOptions instanceof Array) {
    return selectOptions;
  } else if (selectOptions instanceof Object) {
    return Object.values(selectOptions).map(so => [so.name, so.id]);
  } else {
    return selectOptions.split(",").map(so => [so.trim(), so.trim()]);
  }
};

const selectOptionsFromCase = (selectOptions, fieldType) => {
  switch (fieldType) {
    case 'select':
    case 3:
      return checkAndConvertSelectOptions(selectOptions);
    case 6:
      return window.Application.locationSelectOptions;
    case 7:
      return window.Application.positionSelectOptions;
    case 8:
      return window.Application.poolSelectOptions;
    case 9:
      return window.Application.employeeSelectOptions;
    default:
      return null;
  }
};

const dateTimeFieldPattern = (e, props, type) => {
  let value = e.sender.value();
  let formFieldKey = props.formFieldKey;
  let isValid = true;
  let message = "Invalid Selection!";

  if(type === 2 || type === "date"){
    isValid = moment(value, 'MM/DD/YYYY', true).isValid();
    message = "Incorrect format for Date. Please select valid date from Calender";
    value = moment(value).format()
  }
  if(type === 11 || type === "time"){
    isValid = moment(value, 'hh:mm', true).isValid();
    message = "Incorrect format for Time. Please select valid Time Slot from Dropdown";
    value = moment(value).format()
  }
  if(type === "datetime") {
    isValid = moment(value, 'MM/DD/YYYY hh:mm', true).isValid()
    value = moment(value).format()
  }

  if(isValid) {
    props.onChange(value, formFieldKey);
  } else {
    props.onChange(props.formField.value, formFieldKey);
    toastr.error(message);
  }
};

const DigiFormHeader = props => {
  return(
    <div
      style={{
        borderBottom: "1px solid #dadada",
        paddingBottom: 5,
        marginBottom: 10
      }}
      className={props.classes}
    >
      <h4>{props.title}</h4>
    </div>
  )
}

const DigiFormItem = props => {
  const fieldEnabled = props.formField.useStateToggle ? props.stateEnabled : props.formField.enabled;
  if (fieldEnabled) {
    switch (props.formField.type) {
      case 'header':
        return (
          <DigiFormHeader
            title={props.formField.title}
            classes={props.formField.classes}
          />
        );
      case 'text':
      case 'number':
      case 'email':
      case 0:
      case 1:
        return (
          <DigiFormField
            key={props.formFieldKey}
            name={props.formFieldKey}
            label={props.formField.label}
            required={props.formField.required}
            value={props.formField.value}
            type={checkAndConvertFieldType(props.formField.type)}
            fieldErrors={props.fieldErrors[props.formFieldKey]}
            step={props.formField.step}
            min={props.formField.min}
            max={props.formField.max}
            onChange={e => props.onChange(e.target.value, props.formFieldKey)}
          />
        );
      case 'textarea':
      case 10:
        if (props.index >= 0) {
          return (
            <DigiFormTextArea
              key={props.formFieldKey}
              name={props.formFieldKey}
              label={props.formField.label}
              required={props.formField.required}
              value={props.formField.value == "null" ? "" : props.formField.value}
              type={props.formField.type}
              placeholder={props.formField.placeholder}
              errors={props.fieldErrors[props.formFieldKey]}
              onChange={e => props.onChange(e.target.value, props.index, "note")}
            />
          );
        } else {
          return (
            <DigiFormTextArea
              key={props.formFieldKey}
              name={props.formFieldKey}
              label={props.formField.label}
              required={props.formField.required}
              value={props.formField.value == "null" ? "" : props.formField.value}
              type={props.formField.type}
              placeholder={props.formField.placeholder}
              errors={props.fieldErrors[props.formFieldKey]}
              onChange={e => props.onChange(e.target.value, props.formFieldKey)}
            />
          );
        }
      case 'date':
      case 'time':
      case 'datetime':
      case 2:
      case 11:
        return (
          <DigiFormDateTime
            key={props.formFieldKey}
            name={props.formFieldKey}
            label={props.formField.label}
            required={props.formField.required}
            value={props.formField.value}
            type={props.formField.type}
            fieldErrors={props.fieldErrors[props.formFieldKey]}
            onChange={e => dateTimeFieldPattern(e, props, props.formField.type)}
          />
        );
      case 'checkbox':
      case 4:
        return (
          <DigiFormCheckBox
            key={props.formFieldKey}
            name={props.formFieldKey}
            label={props.formField.label}
            required={props.formField.required}
            checked={props.formField.value === 'true' || props.formField.value === true}
            errors={props.fieldErrors[props.formFieldKey]}
            onChange={e => props.onChange(e.target.checked, props.formFieldKey)}
          />
        );
      case 'radiobutton':
      case 5:
        return (
          <DigiFormRadioButtonsStd
            key={props.formFieldKey}
            label={props.formField.label}
            required={props.formField.required}
            items={checkAndConvertSelectOptions(props.formField.select_options)}
            value={props.formField.value || null}
            errors={props.fieldErrors[props.formFieldKey]}
            onChange={e => props.onChange(e.target.value, props.formFieldKey)}
          />
        );
      case 'select':
      case 3:
      case 6:
      case 7:
      case 8:
      case 9:
        return (
          <DigiFormSelect
            key={props.formFieldKey}
            name={props.formFieldKey}
            label={props.formField.label}
            required={props.formField.required}
            value={props.formField.value}
            skipSelect={props.formField.skip_select || false}
            fieldErrors={props.fieldErrors[props.formFieldKey]}
            options={selectOptionsFromCase(props.formField.select_options, props.formField.type)}
            onChange={e => props.onChange(e.target.value, props.formFieldKey)}
          />
        );
      case 'hidden':
        return (
          <DigiFormHidden
            key={props.formFieldKey}
            name={props.formFieldKey}
            value={props.formField.value}
          />
        );
      case 'locations_pools':
        return (
          <DigiFormLocationsPools
            key={props.formFieldKey}
            required={props.formField.required}
            locationValue={props.formField.value}
            poolValue={props.formField.pool_value}
            locationOptions={props.formField.location_options}
            poolOptions={props.formField.pool_options}
            fieldErrors={props.fieldErrors[props.formFieldKey]}
            onChange={props.onChange}
          />
        );
      case 'locations_with_all_locations_toggle':
        return (
          <DigiFormLocationsToggleAll
            key={props.formFieldKey}
            required={props.formField.required}
            value={props.formField.value}
            fieldErrors={props.fieldErrors[props.formFieldKey] || []}
            onChange={props.onChange}
            label={props.formField.label}
            associationName={props.formField.associationName}
            allLocations={props.formField.allLocations}
          />
        );
      case 'custom_fields_questions':
        return (
          <DigiFormCustomFieldsQuestions
            key={props.formFieldKey}
            formName={props.formName}
            customFields={props.formField.custom_fields}
            fieldTypes={props.formField.fieldTypes}
            requiredOptions={props.formField.requiredOptions}
            onChange={props.onChange}
            fieldErrors={props.fieldErrors}
          />
        );
      case 'custom_fields_answers':
        return (
          <DigiFormCustomFieldsAnswers
            key={props.formFieldKey}
            customFields={props.formField.customFields}
            customFieldsAnswers={props.formField.customFieldsAnswers}
            fieldTypes={props.formField.fieldTypes}
            onChange={props.onChange}
            fieldErrors={props.fieldErrors}
          />
        );
      case 'toggle':
        return (
          <DigiFormToggle
            key={props.formFieldKey}
            labelTrue={props.formField.label_true}
            labelFalse={props.formField.label_false}
            required={props.formField.required}
            value={props.formField.value || null}
            errors={props.fieldErrors[props.formFieldKey]}
            onChange={e => props.onChange(e, props.index, "completed")}
          />
        );
      case 'section':
      case 12:
        return (
          <div className="separate-line">
            <div style={{ backgroundColor: "#f0f0f0", padding: "8px", borderRadius: "6px" }}>
              <label className="control-label text-120">{props.formField.label}</label>
              {props.formField.select_options && props.formField.select_options.length > 0 ? (
                <span className="grey-text line-break markdown-content">
                  <Markdown source={props.formField.select_options} />
                </span>
              ) : null}
            </div>
          </div>
        );
      case 'users_multi_select':
        return (
          <DigiFormUsers
            key={props.formFieldKey}
            required={props.formField.required}
            value={props.formField.value}
            fieldErrors={props.fieldErrors[props.formFieldKey] || []}
            onChange={props.onChange}
            label={props.formField.label}
            associationName={props.formField.associationName}
            activeUsers={props.formField.activeUsers || false}
            byLocationIds={props.formField.byLocationIds || "all"}
          />
        );
      case 'signatures_fields':
        return (
          <DigiFormSignaturesFields
            key={props.formFieldKey}
            required={props.formField.required}
            value={props.formField.value}
            fieldErrors={props.fieldErrors}
            onChange={props.onChange}
            label={props.formField.label}
            associationName={props.formField.associationName}
          />
        );
      case 'attachments':
        return (
          <DigiFormAttachments
            key={props.formFieldKey}
            required={props.formField.required}
            fieldErrors={props.fieldErrors[props.formFieldKey]}
            files={props.formField.value}
            onChange={props.onChange}
            associationName={props.formField.associationName}
          />
        )
      case 'record_signatures':
        return (
          <DigiFormRecordSignature
            key={props.formFieldKey}
            value={props.formField.value}
            signatureFields={props.formField.signatureFields}
            fieldErrors={props.fieldErrors}
            onChange={props.onChange}
            associationName={"signatures_attributes"}
          />
        )
      case 'toggle_attachments':
        return (
          <DigiFormToggleAttachments
            key={props.formFieldKey}
            value={props.formField.value}
            fieldErrors={props.fieldErrors[props.formFieldKey]}
            onChange={e => props.onChange(e, 'attachments_enabled')}
          />
        )
      case 'toggle_public_form':
        return (
          <DigiFormTogglePublicForm
            key={props.formFieldKey}
            value={props.formField.value}
            fieldErrors={props.fieldErrors[props.formFieldKey]}
            onChange={e => props.onChange(e, 'public_form')}
          />
        )
      case 'description':
        return (
          <DigiFormDescription
            description={props.formField.description}
          />
        )
      case 'locations_multi_select':
        return (
          <DigiFormLocations
            key={props.formFieldKey}
            required={props.formField.required}
            value={props.formField.value}
            fieldErrors={props.fieldErrors[props.formFieldKey] || []}
            onChange={props.onChange}
            label={props.formField.label}
            associationName={props.formField.associationName}
          />
        )
        break;
      case 'note':
        console.log('DigiFormItem:props.formField', props.formField)
        return (
          <DigiFormNote label={props.formField.label} value={props.formField.value} />
        )
      default:
        return null;
    }
  } else {
    return null;
  }
}

DigiFormItem.propType = {
  locationValue: PropTypes.number,
  poolValue: PropTypes.number,
  locationOptions: PropTypes.array,
  poolOptions: PropTypes.array,
  fieldErrors: PropTypes.array,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  formName: PropTypes.string
};

export default DigiFormItem;
